module.exports = "<div class=breadcrumb__container> <div class=container> <ol class=\"breadcrumb bg-transparent\"> <li class=breadcrumb-item> <a ui-sref={{$ctrl.shCtrl.ngAuthSettings.site.app.header.logo.url}}> <i class=\"fa fa-home\"></i> </a> </li> <li class=\"breadcrumb-item active\"><span>{{$ctrl.pageNameSlug | capitalize}}</span></li> </ol> </div> </div> <div class=container> <div class=row> <div class=\"col-md-12 mb30\"> <advertisement ng-if=$ctrl.cmsData sh-ctrl=$ctrl.shCtrl type-content=espacios positions=1 content-data=$ctrl.cmsData> </advertisement></div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/page/templates/page-base.view.html
 ** module id = 839
 ** module chunks = 7
 **/